<adapt-dialog [maxWidth]="650"
              [showHelpButton]="false">
    <h3 adapt-dialog-title>Edit start date</h3>
    <ng-container adapt-dialog-content>
        <div class="pb-3">
            <label>Start date</label>
            <dx-date-box type="date"
                         data-test="start-date-box"
                         [useMaskBehavior]="true"
                         [value]="connection.startDate"
                         (valueChange)="dateChanged($any($event))">
                <dx-validator>
                    <dxi-validator-validation-rule [adaptEntity]="connection"
                                                   adaptEntityProperty="startDate"></dxi-validator-validation-rule>
                    <dxi-validator-validation-rule type="required"
                                                   message="Date is required"></dxi-validator-validation-rule>
                </dx-validator>
            </dx-date-box>
        </div>

        @if (dateIsFuture) {
            <div class="alert alert-warning"
                 role="alert"><b>Note:</b> The start date being in the future means the user will not have access until that date.</div>
        }

        @if (nonAccessRoleConnectionsChanged; as roleConnections) {
            @if (roleConnections.length > 0) {
                <div class="alert alert-warning"
                     role="alert">
                    <b>Note:</b> The end date of the following role connections will change due to them overlapping with the new start date:
                    <ul>
                        @for (roleConnection of roleConnections; track roleConnection) {
                            <li>{{ roleConnection.role.label }}</li>
                        }
                    </ul>
                </div>
            }
        }
    </ng-container>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [discardConfirmationInstance]="instance"> </adapt-standard-dialog-buttons>
</adapt-dialog>
